import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import './FPSShopInspectionTwo.css';
import { jsPDF } from "jspdf";  // Import jsPDF
import "jspdf-autotable";
import Select from 'react-select'; // Import react-select
import { format } from 'date-fns';
import pds from './pds.PNG';
import ExcelJS from 'exceljs';

const customStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: "4px",
        padding: "2px",

    }),
    dropdownIndicator: (provided) => ({
        ...provided,

        cursor: "pointer", // Change cursor to indicate it's clickable
    }),
    indicatorSeparator: () => ({
        display: "none", // Hide the default separator

    }),
};
const FPSShopInspectionTwo = () => {

    function capitalizeFirstTwoWords(name) {
        if (!name) return name; // Check if name exists
        const words = name.split(' ');
        if (words.length > 1) {
            words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase(); // Capitalize first word
            words[1] = words[1].charAt(0).toUpperCase() + words[1].slice(1).toLowerCase(); // Capitalize second word
        }
        return words.join(' ');
    }
    const formatFullName = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text
                .split(' ') // Split the string by spaces into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
                .join(' '); // Join the words back into a single string with spaces
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    const [dataMessage, setDataMessage] = useState('');
    const [districtId, setDistrictId] = useState("");
    const [subDivisionId, setSubDivisionId] = useState('');
    const [blockId, setBlockId] = useState('');
    const [districts, setDistricts] = useState([]);
    const [subDivisions, setSubDivisions] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [panchayatId, setPanchayatId] = useState("");
    const [panchayats, setPanchayats] = useState([]);
    const [fpsuId, setFpsId] = useState("");  // Ensure this is defined at the top of your component
    const [uniqueFpsId, setUniqueFpsId] = useState("");  // Ensure this is defined at the top of your component
    const [fpshops, setFPShops] = useState([]);
    const [tableData, setTableData] = useState({});
    const [error, setError] = useState(null);  // Define setError here
    const [inspectionDate, setInspectionDate] = useState(null);
    const [inspectionDates, setInspectionDates] = useState([]);
    const [showDownloadPdf, setShowDownloadPdf] = useState(false);
    const reportRef = useRef(null);  // Reference to the report HTML
    const [isOpen, setIsOpen] = useState(false); // To control dropdown open/close



    const modalRef = useRef(null);  // For the modal div
    const modalImageRef = useRef(null);  // For the modal image element
    // const captionRef = useRef(null);  // For the caption element





    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = (localPath) => {
        if (modalRef.current && modalImageRef.current) {
            modalRef.current.style.display = "block";  // Show the modal
            modalImageRef.current.src = localPath;     // Set the image source
            // captionRef.current.innerHTML = localPath;  // Optionally show a caption
        }
    };

    const closeModal = () => {
        if (modalRef.current) {
            modalRef.current.style.display = "none";
        }
    };

    // Your Base64 encoded font (replace this with your actual Base64 font string)



    const generatePDF = () => {
        // Create a new jsPDF instance
        const doc = new jsPDF();

        doc.addImage(pds, 'jpeg', 9.5, 10, 190, 30);  // Image format: 'PNG'

        let yPosition = 45; // Starting Y position

        // Set the font to bold
        doc.setFont("helvetica", "bold");  // "helvetica" is the font, "bold" is the weight


        // Add title
        doc.text("FPS Inspection Report", 73, yPosition);
        yPosition += 10; // Move Y position down for next element

        // Add ma
        // Set initial Y position for the text
        let startY = 25;  // Starting Y position (distance from top of the page)
        // const columnSpacing = 80; // Space between columns
        // Draw the first table (District, Sub Division, Block, etc.)
        const tableHeight = 8;  // Row height for each line
        // Add the first row data
        startY += tableHeight;  // Move down for the next row
        // Draw the second table (Panchayat, FPS ID, Dates)
        const tableHeight2 = 8;  // Row height for each line
        // const tableWidth2 = columnSpacing * 2.38;  // Table width for this table
        startY += tableHeight - 8;  // Add some space between the two tables

        // Add the second row data
        startY += tableHeight2;

        const getLastY = () => {
            return doc.lastAutoTable && doc.lastAutoTable.finalY ? doc.lastAutoTable.finalY : startY + 12.33; // Default Y position
        };

        const inspecOffFeedInfo1 = [
            ...(questionSurveys?.find(survey => survey.question?.questionUid === '55')?.response ? [
                [
                    questionSurveys.find(survey => survey.question?.questionUid === '55')?.question?.questionText || 'No Data',
                    formatFullName(questionSurveys.find(survey => survey.question?.questionUid === '55')?.response || 'No Response')
                ]
            ] : []),
        ];

        // Add Shop Details Section
        const shopDetailsY15 = getLastY() + 6;

        // Set background color (if needed)
        doc.setFillColor(245, 245, 245); // Gray background

        // Set text color for the header
        doc.setTextColor(12, 92, 108); // Dark Blue text
        doc.setFont('helvetica', 'bold');
        // Get current date and time
        const currentDate = new Date();
        const formattedDateAndTime = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()} ${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Loop through `inspecOffFeedInfo1` to add questionText and response dynamically
        let yPosition1 = shopDetailsY15;  // Start position for text

        inspecOffFeedInfo1.forEach((item, index) => {
            // For each question and response, add them to the PDF
            const questionText = item[0] || 'No Data';
            const response = item[1] || 'No Response';

            // Set the position dynamically
            doc.text(` ${questionText} : ${capitalizeFirstTwoWords(response)}  `, 13, yPosition1);
            yPosition += 6;  // Add some space between lines
            // Save the current font settings
            const currentFontSize = doc.internal.getFontSize();
            const currentTextColor = doc.getTextColor();

            // Set font size and color for the specific text
            doc.setTextColor(0, 0, 0)  // Set text color to black
                .setFontSize(11)         // Set font size to 11
                .text(`Report Date: ${formattedDateAndTime}`, 135, yPosition1);

            // Reset the font size and color to original values after this text
            doc.setFontSize(currentFontSize)
                .setTextColor(currentTextColor);



            yPosition += 3;  // Add space before the next question-response pair
        });

        // Define the table columns and autoTable (if needed) for your other content
        const pageWidth015 = doc.internal.pageSize.width;
        const leftMargin015 = 14;
        const rightMargin015 = 14;

        const availableWidth015 = pageWidth015 - leftMargin015 - rightMargin015;

        // Define custom column widths for the table
        const firstColumnWidth015 = availableWidth015 * 0.6;  // 60% of the available width for the first column
        const secondColumnWidth015 = availableWidth015 * 0.4; // 40% of the available width for the second column

        // Highlighting logic: Apply custom style to the row or cell you want to highlight
        doc.autoTable({
            startY: yPosition,  // Start below the section header

            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth015 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth015 }, // Second column takes 40% width
            },
            margin: { left: leftMargin015 },  // Adjust table to fit in the left margin
            didDrawCell: (data) => {
                // Highlight questionText and response cells only
                if (data.column.index === 0 || data.column.index === 1) {  // Column 0: questionText, Column 1: response
                    data.cell.styles.fillColor = [255, 255, 0]; // Yellow background for these cells
                    data.cell.styles.textColor = [0, 0, 0];    // Black text for these cells
                    data.cell.styles.fontStyle = 'bold';        // Bold text for these cells
                }
            }
        });



        // Create user information table
        const userInfo = [
            ["FPS ID", fpsid || "No FPS ID"],
            ["District Name", capitalizeFirstLetter(district) || "No District"],
            ["Sub-Division Name", capitalizeFirstLetter(subDivision) || "No SubDivision"],
            ["Block Name", capitalizeFirstLetter(block) || "No Block"],
            ["Panchayat Name", capitalizeFirstLetter(panchayat) || "No Panchayat"]
        ];

        // Add Shop Details Section
        const shopDetailsY1 = getLastY() + 6;
        // Set background color
        doc.setFillColor(245, 245, 245); // Black background
        // Calculate text width and height
        const textWidth11 = doc.getTextWidth('SHOP DETAILS');
        const padding11 = 141;
        // Draw background rectangle
        doc.rect(14, shopDetailsY1 - 8, textWidth11 + padding11, 10, 'F');
        // Set text color
        doc.setTextColor(12, 92, 108); // White text
        doc.setFont('helvetica', 'bold');
        // Add text
        doc.text('User Information', 16, shopDetailsY1);

        const pageWidth01 = doc.internal.pageSize.width;
        const leftMargin01 = 14;
        const rightMargin01 = 14;

        const availableWidth01 = pageWidth01 - leftMargin01 - rightMargin01;
        // Define custom column widths
        const firstColumnWidth01 = availableWidth01 * 0.6;  // 60% of the available width for the first column
        const secondColumnWidth01 = availableWidth01 * 0.4; // 40% of the available width for the second column
        // Add table with 50% column widths
        doc.autoTable({
            startY: shopDetailsY1 + 2,  // Start below the section header
            body: userInfo,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth01 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth01 }, // Second column takes 40% width
            },
            margin: { left: leftMargin01 },  // Adjust table to fit in the left margin
        });
        // Add Shop Details Table
        const shopDetails = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '1')?.question?.questionText || 'No Data',
            (questionSurveys?.find(survey => survey.question?.questionUid === '1')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '2')?.question?.questionText || 'No Data',
            (questionSurveys?.find(survey => survey.question?.questionUid === '2')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '3')?.question?.questionText || 'No Data',
            (questionSurveys?.find(survey => survey.question?.questionUid === '3')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '4')?.question?.questionText || 'No Data',
            (questionSurveys?.find(survey => survey.question?.questionUid === '4')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '5')?.question?.questionText || 'No Data',
            (questionSurveys?.find(survey => survey.question?.questionUid === '5')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '6')?.question?.questionText || 'No Data',
            questionSurveys?.find(survey => survey.question?.questionUid === '6')?.response || 'No Response'],
        ];
        // Add Shop Details Section
        const shopDetailsY = getLastY() + 8.4;
        // Set background color
        doc.setFillColor(245, 245, 245); // Black background
        // Calculate text width and height
        const textWidth = doc.getTextWidth('SHOP DETAILS');
        const padding = 141;
        // Draw background rectangle
        doc.rect(14, shopDetailsY - 8, textWidth + padding, 10, 'F');
        // Set text color
        doc.setTextColor(12, 92, 108); // White text
        doc.setFont('helvetica', 'bold');
        // Add text
        doc.text('General Information', 16, shopDetailsY);


        const pageWidth101 = doc.internal.pageSize.width;
        const leftMargin101 = 14;
        const rightMargin101 = 14;

        const availableWidth101 = pageWidth101 - leftMargin101 - rightMargin101;
        // Define custom column widths
        const firstColumnWidth101 = availableWidth101 * 0.6;  // 60% of the available width for the first column
        const secondColumnWidth101 = availableWidth101 * 0.4; // 40% of the available width for the second column
        // Add table with 50% column widths
        doc.autoTable({
            startY: shopDetailsY + 2,  // Start below the section header
            body: shopDetails,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth101 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth101 }, // Second column takes 40% width
            },
            margin: { left: leftMargin101 },  // Adjust table to fit in the left margin
        });







        // Add Shop Information Section (with spacing)
        const shopInformationY = getLastY() + 8.4;
        // Add Shop Details Section
        // Set background color
        doc.setFillColor(245, 245, 245); // Black background
        // Calculate text width and height
        const textWidth1 = doc.getTextWidth('SHOP INFORMATIONS');
        const padding1 = 122;
        // Draw background rectangle
        doc.rect(14, shopInformationY - 8, textWidth1 + padding1, 10, 'F');
        // Set text color
        doc.setTextColor(12, 92, 108); // White text
        doc.setFont('helvetica', 'bold');
        // Add text
        doc.text('Shop Operations', 16, shopInformationY);
        // Generate a table for "Shop Information"
        const shopInfo = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '7')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '7')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '8')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '8')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '9')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '9')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '10')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '10')?.response || 'No Response')],
        ];






        const pageWidth10 = doc.internal.pageSize.width;
        const leftMargin10 = 14;
        const rightMargin10 = 14;

        const availableWidth10 = pageWidth10 - leftMargin10 - rightMargin10;
        // Define custom column widths
        const firstColumnWidth10 = availableWidth10 * 0.6;  // 60% of the available width for the first column
        const secondColumnWidth10 = availableWidth10 * 0.4; // 40% of the available width for the second column
        // Add table with 50% column widths
        doc.autoTable({
            startY: shopInformationY + 2,  // Start below the section header
            body: shopInfo,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth10 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth10 }, // Second column takes 40% width
            },
            margin: { left: leftMargin10 },  // Adjust table to fit in the left margin
        });







        // Add "Shop Stock Information" Section
        let shopStockInformationY = getLastY() + 8.4;
        // Check if a new page is required
        if (shopStockInformationY > doc.internal.pageSize.height - 20) {
            doc.addPage();  // Add new page
            shopStockInformationY = 20;  // Reset Y position
        }
        // Set background color
        doc.setFillColor(245, 245, 245);  // Light gray background
        // Calculate text width and height
        const textWidth2 = doc.getTextWidth('SHOP STOCK INFORMATION');
        const padding2 = 104;
        // Draw background rectangle
        doc.rect(14, shopStockInformationY - 8, textWidth2 + padding2, 10, 'F');
        // Set text color and font
        doc.setTextColor(12, 92, 108);  // Custom text color
        doc.setFont('helvetica', 'bold');
        // Add text
        doc.text('Record Maintance', 16, shopStockInformationY);
        // Prepare stock information
        const stockInfo = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '11')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '11')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '12')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '12')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '13')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '13')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '14')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '14')?.response || 'No Response')],
        ];
        // Dynamically set the table startY
        const tableStartY = shopStockInformationY + 2.25;
        // Add table
        const pageWidth11 = doc.internal.pageSize.width;
        const leftMargin11 = 14;
        const rightMargin11 = 14;

        const availableWidth11 = pageWidth11 - leftMargin11 - rightMargin11;
        // Define custom column widths
        const firstColumnWidth11 = availableWidth11 * 0.6;  // 60% of the available width for the first column
        const secondColumnWidth11 = availableWidth11 * 0.4; // 40% of the available width for the second column
        // Add table with 50% column widths
        doc.autoTable({
            startY: tableStartY,  // Start below the section header
            body: stockInfo,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth11 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth11 }, // Second column takes 40% width
            },
            margin: { left: leftMargin11 },  // Adjust table to fit in the left margin
        });









        // Add "Shop Stock Information" Section
        let displayOfInformation = getLastY() + 8.4;
        // Check if a new page is required
        if (displayOfInformation > doc.internal.pageSize.height - 20) {
            doc.addPage();  // Add new page
            displayOfInformation = 20;  // Reset Y position
        }
        // Set background color
        doc.setFillColor(245, 245, 245);  // Light gray background
        // Calculate text width and height
        const textWidth3 = doc.getTextWidth('SHOP STOCK INFORMATION');
        const padding3 = 104;
        // Draw background rectangle
        doc.rect(14, displayOfInformation - 8, textWidth3 + padding3, 10, 'F');
        // Set text color and font
        doc.setTextColor(12, 92, 108);  // Custom text color
        doc.setFont('helvetica', 'bold');
        // Add text
        doc.text('Display Of Information', 16, displayOfInformation);
        // Prepare stock information
        const displayInfo = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '15')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '15')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '16')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '16')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '17')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '17')?.response || 'No Response')],
        ];
        // Dynamically set the table startY
        const tableStartY1 = displayOfInformation + 2.25;
        const pageWidth12 = doc.internal.pageSize.width;
        const leftMargin12 = 14;
        const rightMargin12 = 14;

        const availableWidth12 = pageWidth12 - leftMargin12 - rightMargin12;
        // Define custom column widths
        const firstColumnWidth12 = availableWidth12 * 0.6;  // 60% of the available width for the first column
        const secondColumnWidth12 = availableWidth12 * 0.4; // 40% of the available width for the second column
        // Add table with 50% column widths
        doc.autoTable({
            startY: tableStartY1,  // Start below the section header
            body: displayInfo,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth12 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth12 }, // Second column takes 40% width
            },
            margin: { left: leftMargin12 },  // Adjust table to fit in the left margin
        });









        // Add "Shop Stock Information" Section
        let infrastructure = getLastY() + 8.4; // gap in between the table haeader creating new table
        // Check if a new page is required
        if (infrastructure > doc.internal.pageSize.height - 20) {
            doc.addPage();  // Add new page
            infrastructure = 20;  // Reset Y position
        }
        // Set background color
        doc.setFillColor(245, 245, 245);  // Light gray background
        // Calculate text width and height
        const textWidth4 = doc.getTextWidth('SHOP STOCK INFORMATION');
        const padding4 = 104;  // heading name  background page
        // Draw background rectangle
        doc.rect(14, infrastructure - 8, textWidth4 + padding4, 10, 'F');
        // Set text color and font
        doc.setTextColor(12, 92, 108);  // Custom text color
        doc.setFont('helvetica', 'bold');
        // Add text
        doc.text('Infrastructure', 16, infrastructure);
        // Prepare stock information
        const infrastruInfo = [
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '20')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '20')?.url || '#')],
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '21')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '21')?.url || '#')],
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '22')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '22')?.url || '#')],
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '23')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '23')?.url || '#')],
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '24')?.question?.questionText || '#',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '24')?.url || '#')],
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '25')?.question?.questionText || '#',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '25')?.url || '#')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '18')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '18')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '19')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '19')?.response || 'No Response')]
        ];

        // Dynamically set the table startY
        const tableStartY2 = infrastructure + 2.25;

        // Get the available width for the table (minus the left and right margins)
        const pageWidth1 = doc.internal.pageSize.width;
        const leftMargin1 = 14;
        const rightMargin1 = 14;
        const availableWidth1 = pageWidth1 - leftMargin1 - rightMargin1;

        // Define custom column widths
        const firstColumnWidth1 = availableWidth1 * 0.77;  // 60% of the available width for the first column
        const secondColumnWidth1 = availableWidth1 * 0.23; // 40% of the available width for the second column

        // Add table with 50% column widths
        doc.autoTable({
            startY: tableStartY2,  // Start below the section header
            body: infrastruInfo,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth1 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth1 }, // Second column takes 40% width
            },
            margin: { left: leftMargin1 },  // Adjust table to fit in the left margin
            didDrawCell: function (data) {
                if (data.column.index === 1) {
                    const rowData = infrastruInfo[data.row.index];
                    if (!Array.isArray(rowData) || rowData.length < 2) return;

                    const imageURL = rowData[1];
                    // Only insert if it's actually an image path
                    const isImg = typeof imageURL === 'string' &&
                        (imageURL.startsWith('data:image') ||
                            imageURL.startsWith('http') ||
                            imageURL.startsWith('blob:'));

                    if (isImg && imageURL !== '#') {
                        try {
                            doc.addImage(imageURL, 'JPEG', data.cell.x + 1, data.cell.y + 1, 40, 30);
                            data.cell.text = [];
                            data.cell.raw = "";
                        } catch (error) {
                            console.warn('Image insert failed:', error);
                        }
                    }
                }
            }
        });











        // Add "Shop Stock Information" Section
        let technologyIntegration = getLastY() + 8.4;
        // Check if a new page is required
        if (technologyIntegration > doc.internal.pageSize.height - 20) {
            doc.addPage();  // Add new page
            technologyIntegration = 20;  // Reset Y position
        }
        // Set background color
        doc.setFillColor(245, 245, 245);  // Light gray background
        // Calculate text width and height
        const textWidth5 = doc.getTextWidth('SHOP STOCK INFORMATION');
        const padding5 = 104;
        // Draw background rectangle
        doc.rect(14, technologyIntegration - 8, textWidth5 + padding5, 10, 'F');
        // Set text color and font
        doc.setTextColor(12, 92, 108);  // Custom text color
        doc.setFont('helvetica', 'bold');
        // Add text
        doc.text('Technology Integration', 16, technologyIntegration);
        // Prepare stock information
        const techInteInfo = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '26')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '26')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '27')?.question?.questionText || 'No Data',
            questionSurveys?.find(survey => survey.question?.questionUid === '27')?.response || 'No Response'],
            [questionSurveys?.find(survey => survey.question?.questionUid === '28')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '28')?.response || 'No Response')],
        ];
        // Dynamically set the table startY
        const tableStartY3 = technologyIntegration + 2.25;




        const pageWidth13 = doc.internal.pageSize.width;
        const leftMargin13 = 14;
        const rightMargin13 = 14;

        const availableWidth13 = pageWidth13 - leftMargin13 - rightMargin13;
        // Define custom column widths
        const firstColumnWidth13 = availableWidth13 * 0.6;  // 60% of the available width for the first column
        const secondColumnWidth13 = availableWidth13 * 0.4; // 40% of the available width for the second column
        // Add table with 50% column widths
        doc.autoTable({
            startY: tableStartY3,  // Start below the section header
            body: techInteInfo,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth13 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth13 }, // Second column takes 40% width
            },
            margin: { left: leftMargin13 },  // Adjust table to fit in the left margin
        });
















        // Add "Shop Stock Information" Section
        let beneficiaryTargeting = getLastY() + 8.4;
        // Check if a new page is required
        if (beneficiaryTargeting > doc.internal.pageSize.height - 20) {
            doc.addPage();  // Add new page
            beneficiaryTargeting = 20;  // Reset Y position
        }
        // Set background color
        doc.setFillColor(245, 245, 245);  // Light gray background
        // Calculate text width and height
        const textWidth6 = doc.getTextWidth('SHOP STOCK INFORMATION');
        const padding6 = 104;
        // Draw background rectangle
        doc.rect(14, beneficiaryTargeting - 8, textWidth6 + padding6, 10, 'F');
        // Set text color and font
        doc.setTextColor(12, 92, 108);  // Custom text color
        doc.setFont('helvetica', 'bold');
        // Add text
        doc.text('Beneficiary Targeting & Coverage', 16, beneficiaryTargeting);
        // Prepare stock information
        const beneTarInfo = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '29')?.question?.questionText || 'No Data',
            formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '29')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '30')?.question?.questionText || 'No Data',
            formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '30')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '31')?.question?.questionText || 'No Data',
            formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '31')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '32')?.question?.questionText || 'No Data',
            formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '32')?.response || 'No Response')],


            [questionSurveys?.find(survey => survey.question?.questionUid === '33')?.question?.questionText || 'No Data',
            formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '33')?.response || 'No Response')],
        ];
        // Dynamically set the table startY
        const tableStartY4 = beneficiaryTargeting + 2.25;

        // Get the available width for the table (minus the left and right margins)
        const pageWidth4 = doc.internal.pageSize.width;
        const leftMargin4 = 14;
        const rightMargin4 = 14;
        const availableWidth4 = pageWidth4 - leftMargin4 - rightMargin4;
        // Define custom column widths
        const firstColumnWidth4 = availableWidth4 * 0.6;  // 60% of the available width for the first column
        const secondColumnWidth4 = availableWidth4 * 0.4; // 40% of the available width for the second column

        // Add table with custom column widths
        doc.autoTable({
            startY: tableStartY4,  // Start below the section header
            body: beneTarInfo,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth4 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth4 }, // Second column takes 40% width
            },
            margin: { left: leftMargin4 },  // Adjust table to fit in the left margin
        });















        // Add "Shop Stock Information" Section
        let invenotoryVerification = getLastY() + 8.4;
        // Check if a new page is required
        if (invenotoryVerification > doc.internal.pageSize.height - 20) {
            doc.addPage();  // Add new page
            invenotoryVerification = 20;  // Reset Y position
        }
        // Set background color
        doc.setFillColor(245, 245, 245);  // Light gray background
        // Calculate text width and height
        const textWidth7 = doc.getTextWidth('SHOP STOCK INFORMATION');
        const padding7 = 104;
        // Draw background rectangle
        doc.rect(14, invenotoryVerification - 8, textWidth7 + padding7, 10, 'F');
        // Set text color and font
        doc.setTextColor(12, 92, 108);  // Custom text color
        doc.setFont('helvetica', 'bold');
        // Add text
        doc.text('Inventory Verification', 16, invenotoryVerification);
        // Prepare stock information
        const inveVeriInfo = [
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '34')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '34')?.response || 'No Response')
            ],
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '35')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '35')?.response || 'No Response')
            ],
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '38')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '38')?.response || 'No Response')
            ],
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '40')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '40')?.response || 'No Response')
            ],
            // Wheat
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '36')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '36')?.response || 'No Response')
            ],
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '37')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '37')?.response || 'No Response')
            ],
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '39')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '39')?.response || 'No Response')
            ],
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '41')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '41')?.response || 'No Response')
            ]
        ];

        const tableStartY5 = invenotoryVerification + 2.25;
        // Get the available width for the table (minus the left and right margins)
        const pageWidth3 = doc.internal.pageSize.width;
        const leftMargin3 = 14;
        const rightMargin3 = 14;
        const availableWidth3 = pageWidth3 - leftMargin3 - rightMargin3;
        // Define custom column widths
        const firstColumnWidth3 = availableWidth3 * 0.6;  // 60% of the available width for the first column
        const secondColumnWidth3 = availableWidth3 * 0.4; // 40% of the available width for the second column

        // Add table with custom column widths
        doc.autoTable({
            startY: tableStartY5,  // Start below the section header
            body: inveVeriInfo,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth3 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth3 }, // Second column takes 40% width
            },
            margin: { left: leftMargin3 },  // Adjust table to fit in the left margin
        });












        // Add Tiro Devanagari font to PDF
        const TiroDevanagariHindiBase64 = process.env.BASE_URL_HINDI;
        doc.addFileToVFS('TiroDevanagariHindi-Regular.ttf', TiroDevanagariHindiBase64);
        doc.addFont('TiroDevanagariHindi-Regular.ttf', 'tiroDevanagari', 'normal');

        // Set the font for the entire document (optional, if needed globally)
        doc.setFont('tiroDevanagari', 'normal');

        // Add Beneficiary Feedback Section
        let beneficiaryFeedback = getLastY() + 8.4;
        if (beneficiaryFeedback > doc.internal.pageSize.height - 20) {
            doc.addPage();
            beneficiaryFeedback = 20;
        }

        // Header Section
        doc.setFillColor(245, 245, 245);
        const textWidth8 = doc.getTextWidth('BENEFICIARY FEEDBACK');
        const padding8 = 111.5;
        doc.rect(14, beneficiaryFeedback - 8, textWidth8 + padding8, 10, 'F');
        doc.setTextColor(12, 92, 108);
        doc.setFont('helvetica', 'bold');
        doc.text('Beneficiary Feedback', 16, beneficiaryFeedback);

        // Prepare Feedback Information
        const beneFeedInfo = benQuestionSurveys?.map((survey) => {
            const surveyInfo = [
                ['Ration Card Number', survey?.rationNumber || 'No Data'],
                ['Card Holder Name', capitalizeFirstTwoWords(survey?.cardHolderName) || 'No Data']
            ];

            const questionResponses = survey?.benQuestionResponseArray
                ?.filter(question => question?.questionText !== "Ration/Aadhar Card No" && question?.questionText !== "Card Holder Name")
                .map(question => [
                    question?.questionText || 'No Data',
                    question?.response || 'No Response'
                ]) || [];

            return [...surveyInfo, ...questionResponses];
        }).flat();

        // Table Settings
        const tableStartY6 = beneficiaryFeedback + 2.25;
        const pageWidth2 = doc.internal.pageSize.width;
        const leftMargin2 = 14;
        const rightMargin2 = 14;
        const availableWidth2 = pageWidth2 - leftMargin2 - rightMargin2;
        const firstColumnWidth2 = availableWidth2 * 0.6;
        const secondColumnWidth2 = availableWidth2 * 0.4;

        // Add Table with Hindi Font
        doc.autoTable({
            startY: tableStartY6,
            body: beneFeedInfo.map(item => {
                const isRationNumberBold = item[0] === 'Ration Card Number';

                return [
                    { content: item[0], styles: { fontStyle: 'normal' } },
                    {
                        content: item[1],
                        styles: isRationNumberBold
                            ? { fontStyle: 'bold', textColor: [0, 0, 0] }
                            : { fontStyle: 'normal', font: 'tiroDevanagari' }  // Apply Hindi font here
                    }
                ];
            }),
            theme: 'grid',
            styles: {
                fontSize: 10.5,
                font: 'tiroDevanagari'  // Apply Hindi font globally in the table
            },
            columnStyles: {
                0: { cellWidth: firstColumnWidth2 },
                1: { cellWidth: secondColumnWidth2 }
            },
            margin: { left: leftMargin2 }
        });

        // Regular expression to check if the string contains Hindi vowels and consonants (Devanagari script)
        const isValidHindiResponse = (response) => {
            const hindiRegex = /[\u0900-\u097F]/;
            return hindiRegex.test(response);
        };

        function cleanText(text) {
            return text.replace(/[^\x20-\x7E\u0900-\u097F]/g, '');
        }

        let inspectingOfficer = getLastY() + 8.4;
        if (inspectingOfficer > doc.internal.pageSize.height - 20) {
            doc.addPage();
            inspectingOfficer = 20;
        }

        doc.setFillColor(245, 245, 245);
        const textWidth9 = doc.getTextWidth('SHOP STOCK INFORMATION');
        const padding9 = 104;
        doc.rect(14, inspectingOfficer - 8, textWidth9 + padding9, 10, 'F');
        doc.setTextColor(12, 92, 108);
        doc.setFont('helvetica', 'bold');
        doc.text('Inspecting Officer Feedback', 16, inspectingOfficer);

        // Register Hindi font
        // const TiroDevanagariHindiBase64 = process.env.BASE_URL_HINDI;
        doc.addFileToVFS('TiroDevanagariHindi-Regular.ttf', TiroDevanagariHindiBase64);
        doc.addFont('TiroDevanagariHindi-Regular.ttf', 'tiroDevanagari', 'normal');

        // Prepare table data
        const inspecOffFeedInfo = [];

        // Always add questionUid '53'
        const hindiSurvey = questionSurveys.find(survey => survey.question?.questionUid === '53');
        if (hindiSurvey) {
            const cleanedHindiResponse = cleanText(hindiSurvey?.response || 'No Response');
            inspecOffFeedInfo.push([
                hindiSurvey.question?.questionText || 'No Data',
                cleanedHindiResponse
            ]);
        }

        // Add questionUid 54 image
        const img54 = geoTaggedPhotos?.find(s => s.question?.questionUid === '54');
        if (img54?.url) {
            inspecOffFeedInfo.push([
                img54.question?.questionText || 'No Data',
                getLocalImagePath(img54.url || '#')
            ]);
        }

        // Add remaining questionUids
        const q55 = questionSurveys.find(s => s.question?.questionUid === '55');
        if (q55?.response) {
            inspecOffFeedInfo.push([
                q55.question?.questionText || 'No Data',
                formatFullName(q55.response || 'No Response')
            ]);
        }

        const q56 = questionSurveys.find(s => s.question?.questionUid === '56');
        if (q56?.response) {
            inspecOffFeedInfo.push([
                q56.question?.questionText || 'No Data',
                q56.response || 'No Response'
            ]);
        }

        const q57 = questionSurveys.find(s => s.question?.questionUid === '57');
        if (q57?.response) {
            inspecOffFeedInfo.push([
                q57.question?.questionText || 'No Data',
                q57.response || 'No Response'
            ]);
        }


        // Add questionUid 58 image
        const img58 = geoTaggedPhotos?.find(s => s.question?.questionUid === '58');
        if (img58?.url) {
            inspecOffFeedInfo.push([
                img58.question?.questionText || 'No Data',
                getLocalImagePath(img58.url || '#')
            ]);
        }

        // Table rendering
        const tableStartY7 = inspectingOfficer + 2.25;
        const pageWidth = doc.internal.pageSize.width;
        const leftMargin = 14;
        const rightMargin = 14;
        const availableWidth = pageWidth - leftMargin - rightMargin;
        const firstColumnWidth = availableWidth * 0.77;
        const secondColumnWidth = availableWidth * 0.23;

        doc.autoTable({
            startY: tableStartY7,
            body: inspecOffFeedInfo,
            theme: 'grid',
            styles: {
                fontSize: 10,
                textColor: [64, 64, 64]
            },
            columnStyles: {
                0: { cellWidth: firstColumnWidth, textColor: [64, 64, 64] },
                1: { cellWidth: secondColumnWidth, textColor: [64, 64, 64] }
            },
            margin: { left: leftMargin },
            didDrawCell: function (data) {
                const rowData = inspecOffFeedInfo[data.row.index];
                if (!rowData || rowData.length < 2) return;

                const questionText = rowData[0];
                const cellData = rowData[1];

                // 1. Draw white background for the entire cell
                doc.setFillColor(255, 255, 255); // White background
                doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'F');

                // 2. Draw cell borders (to maintain grid lines)
                doc.setDrawColor(200, 200, 200); // Light gray border color
                doc.setLineWidth(0.2);
                doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height);

                // Handle second column content
                if (data.column.index === 1) {
                    if (typeof cellData === 'string' && (cellData.startsWith('http') || cellData.startsWith('data:image'))) {
                        try {
                            // Add white background specifically for the image area
                            doc.setFillColor(255, 255, 255);
                            doc.rect(data.cell.x + 1, data.cell.y + 1, 40, 22, 'F');
                            doc.addImage(cellData, 'JPEG', data.cell.x + 1, data.cell.y + 1, 40, 22);

                            // Redraw borders around image area
                            doc.setDrawColor(200, 200, 200);
                            doc.rect(data.cell.x + 1, data.cell.y + 1, 40, 22);
                        } catch (error) {
                            console.error('Error adding image:', error);
                            doc.setFont('helvetica', 'normal');
                            doc.setTextColor(69, 69, 69);
                            doc.text('Image load failed', data.cell.x + 2, data.cell.y + 5);
                        }
                    } else {
                        // Handle text content
                        const isHindi = isValidHindiResponse(cellData);
                        doc.setFont(isHindi ? 'tiroDevanagari' : 'helvetica', 'normal');
                        doc.setTextColor(69, 69, 69);
                        const splitText = doc.splitTextToSize(cellData, secondColumnWidth - 4);
                        doc.text(splitText, data.cell.x + 2, data.cell.y + 5);
                    }
                }

                // Handle first column (question text)
                if (data.column.index === 0) {
                    doc.setFont('helvetica', 'normal');
                    doc.setTextColor(69, 69, 69);
                    const splitText = doc.splitTextToSize(questionText, firstColumnWidth - 4);
                    doc.text(splitText, data.cell.x + 2, data.cell.y + 5);
                }
            }

        });

        doc.save(`${fpsId}.pdf`);

    };


    // console.log("PDF Data.... : ", generatePDF);



    const generateExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('FPS Inspection Report');
        // Title
        worksheet.mergeCells('A1:B1');
        worksheet.getCell('A1').value = 'FPS Inspection Report';
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'F7912B' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };


        worksheet.addRow([]);
        // Merging cells for header
        worksheet.mergeCells('A2:B2');
        const mainHeader17 = worksheet.getCell('A2');



        // Retrieve the question and response based on the survey data
        const questionSurvey = questionSurveys?.find(survey => survey.question?.questionUid === '55');
        const questionText = questionSurvey?.question?.questionText || 'No Data';
        const response = formatFullName(questionSurvey?.response || 'No Response');

        // Add enough spaces to push "Report Date" to the right

        mainHeader17.value = `${questionText}: ${response}`;

        // Apply styles to the merged cell (A2)
        mainHeader17.font = {
            bold: true,    // Make text bold
            size: 11,      // Set font size
        };

        // Align the text in the merged cell
        mainHeader17.alignment = {
            horizontal: 'left',  // Left align the first part (questionText: response)
            vertical: 'middle',  // Center align vertically
        };

        // Apply background color to the merged cell (A2)
        mainHeader17.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke)
        };

        // Apply color for the first part (questionText: response)
        mainHeader17.font.color = { argb: '0C5C6C' }; // Set color for the first part (dark gray)




        // Apply black color to the Report Date part
        worksheet.getCell('A2').font = {
            color: { argb: '000000' } // Set the second part (Report Date) text to black
        };
        worksheet.addRow([]);
        worksheet.mergeCells('A3:B3');
        const mainHeader18 = worksheet.getCell('B3');

        // Get the current date and time
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        mainHeader18.value = `Report Date: ${formattedDateTime}`;
        mainHeader18.font = {
            bold: true,    // Make text bold
            size: 11,      // Set font size
        };

        // Align the text in the merged cell
        mainHeader18.alignment = {
            horizontal: 'right',  // Left align the first part (questionText: response)
            vertical: 'middle',  // Center align vertically
        };





        // Apply black color to the Report Date part
        worksheet.getCell('B3').font = {
            color: { argb: '000000' } // Set the second part (Report Date) text to black
        };

        // Add User Information Header
        worksheet.addRow([]);
        //worksheet.addRow(['User Information']);
        // Merge cells A2 to B2 for "User Information" header
        worksheet.mergeCells('A4:B4');
        const userInfoHeader = worksheet.getCell('A4');
        userInfoHeader.value = 'User Information';
        userInfoHeader.font = { bold: true, size: 14 };
        userInfoHeader.alignment = { horizontal: 'center', vertical: 'middle' };
        userInfoHeader.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'f2f2f2' } };
        userInfoHeader.font.color = { argb: '0C5C6C' };
        // Define User Information Data
        const userInfo = [
            ['FPS ID', fpsid || 'No FPS ID'],
            ['District Name', capitalizeFirstLetter(district) || 'No District'],
            ['Sub-Division Name', capitalizeFirstLetter(subDivision) || 'No SubDivision'],
            ['Block Name', capitalizeFirstLetter(block) || 'No Block'],
            ['Panchayat Name', capitalizeFirstLetter(panchayat) || 'No Panchayat']
        ];

        // Add rows for User Information
        userInfo.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row
            row.font = { size: 10 };
            row.alignment = { horizontal: 'left', vertical: 'middle' };

            // Apply alternating row colors or similar (optional)
            row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' } };
            row.font.color = { argb: '000000' }; // Black text color

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1);
            firstCell.font = { bold: false, color: { argb: '000000' } };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2);
            secondCell.font = { color: { argb: '33bbff' } }; // Blue text color
        });


        // Add Shop Details (General Information)
        worksheet.addRow([]);
        worksheet.addRow(['General Information']);


        // Merge cells A1 to B1
        worksheet.mergeCells('A11:B11');

        // Access the merged cell (A1)
        const mainHeader = worksheet.getCell('A11');
        mainHeader.value = 'General Information'; // Set the value in the merged cells

        // Apply styles to the merged cell (A1)
        mainHeader.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)



        const shopDetails = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '1')?.question?.questionText || 'No Data',
            (questionSurveys?.find(survey => survey.question?.questionUid === '1')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '2')?.question?.questionText || 'No Data',
            (questionSurveys?.find(survey => survey.question?.questionUid === '2')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '3')?.question?.questionText || 'No Data',
            (questionSurveys?.find(survey => survey.question?.questionUid === '3')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '4')?.question?.questionText || 'No Data',
            (questionSurveys?.find(survey => survey.question?.questionUid === '4')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '5')?.question?.questionText || 'No Data',
            (questionSurveys?.find(survey => survey.question?.questionUid === '5')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '6')?.question?.questionText || 'No Data',
            (questionSurveys?.find(survey => survey.question?.questionUid === '6')?.response || 'No Response')],
        ];

        // Add rows to the sheet for Shop Details
        // Add rows for each item in shopDetails
        shopDetails.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row in shopDetails
            row.font = {
                size: 10,          // Set font size for rows (optional, adjust as needed)
            };

            row.alignment = {
                horizontal: 'left', // Left align text horizontally
                vertical: 'middle', // Center align vertically
            };

            // Apply alternating row colors or similar (optional)
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }, // Set the background to white for rows (or change color if needed)
            };

            row.font.color = { argb: '000000' }; // Black text color (hex: #000000)

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1); // First column cell (column A)
            firstCell.font = {
                // bold: true,        // Make text bold
                color: { argb: '000000' }, // Black text color
            };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2); // Second column cell (column B)
            secondCell.font = {
                color: { argb: '33bbff' }, // Blue text color (hex: #0000FF)
            };
        });

        // Add Shop Information (Shop Operations)
        worksheet.addRow([]);
        worksheet.addRow(['Shop Operations']);


        // Merge cells A1 to B1
        worksheet.mergeCells('A19:B19');

        // Access the merged cell (A1)
        const mainHeader1 = worksheet.getCell('A19');
        mainHeader1.value = 'Shop Operation'; // Set the value in the merged cells

        // Apply styles to the merged cell (A1)
        mainHeader1.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader1.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader1.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader1.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)



        const shopInfo = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '7')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '7')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '8')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '8')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '9')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '9')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '10')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '10')?.response || 'No Response')],
        ];

        // Add rows to the sheet for Shop Information

        // Add rows for each item in shopDetails
        shopInfo.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row in shopDetails
            row.font = {
                size: 10,          // Set font size for rows (optional, adjust as needed)
            };

            row.alignment = {
                horizontal: 'left', // Left align text horizontally
                vertical: 'middle', // Center align vertically
            };

            // Apply alternating row colors or similar (optional)
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }, // Set the background to white for rows (or change color if needed)
            };

            row.font.color = { argb: '000000' }; // Black text color (hex: #000000)

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1); // First column cell (column A)
            firstCell.font = {
                // bold: true,        // Make text bold
                color: { argb: '000000' }, // Black text color
            };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2); // Second column cell (column B)
            secondCell.font = {
                color: { argb: '33bbff' }, // Blue text color (hex: #0000FF)
            };
        });

        // Add Shop Stock Information (Record Maintenance)
        worksheet.addRow([]);
        worksheet.addRow(['Record Maintance']);


        // Merge cells A1 to B1
        worksheet.mergeCells('A25:B25');

        // Access the merged cell (A1)
        const mainHeader2 = worksheet.getCell('A25');
        mainHeader2.value = 'Record Maintance'; // Set the value in the merged cells

        // Apply styles to the merged cell (A1)
        mainHeader2.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader2.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader2.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader2.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)



        const stockInfo = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '11')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '11')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '12')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '12')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '13')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '13')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '14')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '14')?.response || 'No Response')],
        ];

        // Add rows to the sheet for Shop Stock Information

        // Add rows for each item in shopDetails
        stockInfo.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row in shopDetails
            row.font = {
                size: 10,          // Set font size for rows (optional, adjust as needed)
            };

            row.alignment = {
                horizontal: 'left', // Left align text horizontally
                vertical: 'middle', // Center align vertically
            };

            // Apply alternating row colors or similar (optional)
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }, // Set the background to white for rows (or change color if needed)
            };

            row.font.color = { argb: '000000' }; // Black text color (hex: #000000)

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1); // First column cell (column A)
            firstCell.font = {
                // bold: true,        // Make text bold
                color: { argb: '000000' }, // Black text color
            };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2); // Second column cell (column B)
            secondCell.font = {
                color: { argb: '33bbff' }, // Blue text color (hex: #0000FF)
            };
        });

        worksheet.addRow([]);
        worksheet.addRow(['Display Of Information']);

        // Merge cells A1 to B1
        worksheet.mergeCells('A31:B31');

        // Access the merged cell (A1)
        const mainHeader3 = worksheet.getCell('A31');
        mainHeader3.value = 'Display Of Information'; // Set the value in the merged cells

        // Apply styles to the merged cell (A23)
        mainHeader3.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader3.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader3.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader3.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)




        const displayInfo = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '15')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '15')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '16')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '16')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '17')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '17')?.response || 'No Response')],
        ];

        // Add rows to the sheet for Shop Stock Information


        // Add rows for each item in shopDetails
        displayInfo.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row in shopDetails
            row.font = {
                size: 10,          // Set font size for rows (optional, adjust as needed)
            };

            row.alignment = {
                horizontal: 'left', // Left align text horizontally
                vertical: 'middle', // Center align vertically
            };

            // Apply alternating row colors or similar (optional)
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }, // Set the background to white for rows (or change color if needed)
            };

            row.font.color = { argb: '000000' }; // Black text color (hex: #000000)

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1); // First column cell (column A)
            firstCell.font = {
                // bold: true,        // Make text bold
                color: { argb: '000000' }, // Black text color
            };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2); // Second column cell (column B)
            secondCell.font = {
                color: { argb: '33bbff' }, // Blue text color (hex: #0000FF)
            };
        });
        worksheet.addRow([]);
        worksheet.addRow(['Infrastructure']);

        // Merge cells A1 to B1
        worksheet.mergeCells('A36:B36');

        // Access the merged cell (A1)
        const mainHeader4 = worksheet.getCell('A36');
        mainHeader4.value = 'Infrastructure'; // Set the value in the merged cells

        // Apply styles to the merged cell (A23)
        mainHeader4.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader4.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader4.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader4.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)



        const infrastruInfo = [
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '20')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '20')?.url || '#')],
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '21')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '21')?.url || '#')],
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '22')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '22')?.url || '#')],
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '23')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '23')?.url || '#')],
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '24')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '24')?.url || '#')],

            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '25')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '25')?.url || '#')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '18')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '18')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '19')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '19')?.response || 'No Response')],

        ];


        // Add rows for each item in shopDetails
        infrastruInfo.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row in shopDetails
            row.font = {
                size: 10,          // Set font size for rows (optional, adjust as needed)
            };

            row.alignment = {
                horizontal: 'left', // Left align text horizontally
                vertical: 'middle', // Center align vertically
            };

            // Apply alternating row colors or similar (optional)
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }, // Set the background to white for rows (or change color if needed)
            };

            row.font.color = { argb: '000000' }; // Black text color (hex: #000000)

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1); // First column cell (column A)
            firstCell.font = {
                // bold: true,        // Make text bold
                color: { argb: '000000' }, // Black text color
            };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2); // Second column cell (column B)
            secondCell.font = {
                color: { argb: '33bbff' }, // Blue text color (hex: #0000FF)
            };
        });




        worksheet.addRow([]);
        worksheet.addRow(['Technology Integration']);

        // Merge cells A1 to B1
        worksheet.mergeCells('A46:B46');

        // Access the merged cell (A1)
        const mainHeader5 = worksheet.getCell('A46');
        mainHeader5.value = 'Technology Integration'; // Set the value in the merged cells

        // Apply styles to the merged cell (A23)
        mainHeader5.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader5.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader5.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader5.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)



        const techInteInfo = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '26')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '26')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '27')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '27')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '28')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '28')?.response || 'No Response')],
        ];

        // Add rows for each item in shopDetails
        techInteInfo.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row in shopDetails
            row.font = {
                size: 10,          // Set font size for rows (optional, adjust as needed)
            };

            row.alignment = {
                horizontal: 'left', // Left align text horizontally
                vertical: 'middle', // Center align vertically
            };

            // Apply alternating row colors or similar (optional)
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }, // Set the background to white for rows (or change color if needed)
            };

            row.font.color = { argb: '000000' }; // Black text color (hex: #000000)

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1); // First column cell (column A)
            firstCell.font = {
                // bold: true,        // Make text bold
                color: { argb: '000000' }, // Black text color
            };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2); // Second column cell (column B)
            secondCell.font = {
                color: { argb: '33bbff' }, // Blue text color (hex: #0000FF)
            };
        });
        worksheet.addRow([]);
        worksheet.addRow(['Beneficiary Targeting & Coverage']);
        // Merge cells A1 to B1
        worksheet.mergeCells('A51:B51');

        // Access the merged cell (A1)
        const mainHeader6 = worksheet.getCell('A51');
        mainHeader6.value = 'Beneficiary Targeting & Coverage'; // Set the value in the merged cells

        // Apply styles to the merged cell (A23)
        mainHeader6.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader6.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader6.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader6.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)



        const beneTarInfo = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '29')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '29')?.response || 'No Response'))],

            [questionSurveys?.find(survey => survey.question?.questionUid === '30')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '30')?.response || 'No Response'))],
            [questionSurveys?.find(survey => survey.question?.questionUid === '31')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '31')?.response || 'No Response'))],

            [questionSurveys?.find(survey => survey.question?.questionUid === '32')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '32')?.response || 'No Response'))],

            [questionSurveys?.find(survey => survey.question?.questionUid === '33')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '33')?.response || 'No Response'))],
        ];

        // Add rows for each item in shopDetails
        beneTarInfo.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row in shopDetails
            row.font = {
                size: 10,          // Set font size for rows (optional, adjust as needed)
            };

            row.alignment = {
                horizontal: 'left', // Left align text horizontally
                vertical: 'middle', // Center align vertically
            };

            // Apply alternating row colors or similar (optional)
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }, // Set the background to white for rows (or change color if needed)
            };

            row.font.color = { argb: '000000' }; // Black text color (hex: #000000)

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1); // First column cell (column A)
            firstCell.font = {
                // bold: true,        // Make text bold
                color: { argb: '000000' }, // Black text color
            };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2); // Second column cell (column B)
            secondCell.font = {
                color: { argb: '33bbff' }, // Blue text color (hex: #0000FF)
            };
        });
        worksheet.addRow([]);
        // worksheet.addRow(['Inventory Verification']);
        // Merge cells A1 to B1
        worksheet.mergeCells('A59:B59');

        // Access the merged cell (A1)
        const mainHeader7 = worksheet.getCell('A59');
        mainHeader7.value = 'Inventory Verification'; // Set the value in the merged cells

        // Apply styles to the merged cell (A23)
        mainHeader7.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader7.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader7.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader7.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)



        const inveVeriInfo = [
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '34')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '34')?.response || 'No Response')
            ],
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '35')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '35')?.response || 'No Response')
            ],
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '38')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '38')?.response || 'No Response')
            ],
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '40')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '40')?.response || 'No Response')
            ],
            // Wheat
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '36')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '36')?.response || 'No Response')
            ],
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '37')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '37')?.response || 'No Response')
            ],
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '39')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '39')?.response || 'No Response')
            ],
            [
                questionSurveys?.find(survey => survey.question?.questionUid === '41')?.question?.questionText || 'No Data',
                formatNumber(questionSurveys?.find(survey => survey.question?.questionUid === '41')?.response || 'No Response')
            ]
        ];
        // Add rows for each item in shopDetails
        inveVeriInfo.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row in shopDetails
            row.font = {
                size: 10,          // Set font size for rows (optional, adjust as needed)
            };

            row.alignment = {
                horizontal: 'left', // Left align text horizontally
                vertical: 'middle', // Center align vertically
            };

            // Apply alternating row colors or similar (optional)
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }, // Set the background to white for rows (or change color if needed)
            };

            row.font.color = { argb: '000000' }; // Black text color (hex: #000000)

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1); // First column cell (column A)
            firstCell.font = {
                // bold: true,        // Make text bold
                color: { argb: '000000' }, // Black text color
            };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2); // Second column cell (column B)
            secondCell.font = {
                color: { argb: '33bbff' }, // Blue text color (hex: #0000FF)
            };
        });
        worksheet.addRow([]);
        // worksheet.addRow(['Beneficiary Feedback']);

        // Merge cells A1 to B1
        worksheet.mergeCells('A72:B72');

        // Access the merged cell (A1)
        const mainHeader8 = worksheet.getCell('A72');
        mainHeader8.value = 'Beneficiary Feedback'; // Set the value in the merged cells

        // Apply styles to the merged cell (A23)
        mainHeader8.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader8.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader8.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader8.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)

        //console.log('benQuestionSurveys', benQuestionSurveys);

        // Define the columns for the worksheet
        // Define columns for the worksheet


        // Iterate over the surveys and add data to the worksheet
        benQuestionSurveys.forEach(survey => {
            // Create the Ration Number and Card Holder Name row (fixed first row)
            const staticData = [
                { label: 'Ration Card Number', value: survey?.rationNumber || 'No Data' },
                { label: 'Card Holder Name', value: capitalizeFirstTwoWords(survey?.cardHolderName) || 'No Data' }
            ];

            // Add static data to the left side with black color and bold text
            worksheet.addRow([staticData[0].label, staticData[0].value, '', '']);
            worksheet.getCell(`A${worksheet.lastRow.number}`).font = { bold: true, color: { argb: '000000' } }; // Static label in black, bold
            worksheet.getCell(`B${worksheet.lastRow.number}`).font = { bold: true, color: { argb: '000000' } }; // Dynamic value in blue, bold

            worksheet.addRow([staticData[1].label, staticData[1].value, '', '']);
            //worksheet.getCell(`A${worksheet.lastRow.number}`).font = { bold: true, color: { argb: '000000' } }; // Static label in black, bold
            worksheet.getCell(`B${worksheet.lastRow.number}`).font = { color: { argb: '33bbff' } }; // Dynamic value in blue, bold

            // Process the questions and responses (excluding "Card Holder Name")
            // Process the questions and responses (excluding "Card Holder Name")
            const questionResponses = survey?.benQuestionResponseArray
                ?.filter(question => question?.questionText !== "Ration/Aadhar Card No" && question?.questionText !== "Card Holder Name")  // Exclude "Card Holder Name"
                .map(question => ({
                    question: question?.questionText || 'No Data',  // Question text
                    response: question?.response || 'No Response'   // Response text
                })) || [];

            // Add question-response pairs to the worksheet
            questionResponses.forEach((item) => {
                const rowIndex = worksheet.lastRow.number + 1;
                worksheet.addRow([item.question, item.response]);  // Add each question-response pair as a new row

                // Apply specific color to the response
                worksheet.getCell(`B${rowIndex}`).font = { color: { argb: '33bbff' } }; // Response in bold, custom color (red-like

            });
        });

        const nextRowIndex = worksheet.lastRow.number + 2;
        worksheet.addRow([]);
        worksheet.addRow(['Inspecting Officer Feedback']);
        // Merge cells in the dynamic row (using the dynamically calculated row index)
        worksheet.mergeCells(`A${nextRowIndex}:B${nextRowIndex}`);

        // Access the merged cell (e.g., A{nextRowIndex}) and set the value
        const mainHeader9 = worksheet.getCell(`A${nextRowIndex}`);
        mainHeader9.value = 'Inspecting Officer Feedback';   // Set the value in the merged cells

        // Apply styles to the merged cell (A23)
        mainHeader9.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader9.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader9.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader9.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)



        const inspecOffFeedInfo = [
            // Checking the existence of both questionText and response, or URL
            ...(questionSurveys?.find(survey => survey.question?.questionUid === '53')?.response ? [
                [
                    questionSurveys.find(survey => survey.question?.questionUid === '53')?.question?.questionText || 'No Data',
                    questionSurveys.find(survey => survey.question?.questionUid === '53')?.response || 'No Response'
                ]
            ] : []),

            ...(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '54')?.url ? [
                [
                    geoTaggedPhotos.find(survey => survey.question?.questionUid === '54')?.question?.questionText || 'No Data',
                    geoTaggedPhotos.find(survey => survey.question?.questionUid === '54')?.url || 'No Response'
                ]
            ] : []),

            ...(questionSurveys?.find(survey => survey.question?.questionUid === '55')?.response ? [
                [
                    questionSurveys.find(survey => survey.question?.questionUid === '55')?.question?.questionText || 'No Data',
                    formatFullName(questionSurveys.find(survey => survey.question?.questionUid === '55')?.response || 'No Response')
                ]
            ] : []),

            ...(questionSurveys?.find(survey => survey.question?.questionUid === '56')?.response ? [
                [
                    questionSurveys.find(survey => survey.question?.questionUid === '56')?.question?.questionText || 'No Data',
                    questionSurveys.find(survey => survey.question?.questionUid === '56')?.response || 'No Response'
                ]
            ] : []),

            ...(questionSurveys?.find(survey => survey.question?.questionUid === '57')?.response ? [
                [
                    questionSurveys.find(survey => survey.question?.questionUid === '57')?.question?.questionText || 'No Data',
                    questionSurveys.find(survey => survey.question?.questionUid === '57')?.response || 'No Response'
                ]
            ] : []),

            ...(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '58')?.url ? [
                [
                    geoTaggedPhotos.find(survey => survey.question?.questionUid === '58')?.question?.questionText || 'No Data',
                    getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '58')?.url || '#')
                ]
            ] : [])
        ];



        // Add rows for each item in shopDetails
        inspecOffFeedInfo.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row in shopDetails
            row.font = {
                size: 10,          // Set font size for rows (optional, adjust as needed)
            };

            row.alignment = {
                horizontal: 'left', // Left align text horizontally
                vertical: 'middle', // Center align vertically
            };

            // Apply alternating row colors or similar (optional)
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }, // Set the background to white for rows (or change color if needed)
            };

            row.font.color = { argb: '000000' }; // Black text color (hex: #000000)

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1); // First column cell (column A)
            firstCell.font = {
                // bold: true,        // Make text bold
                color: { argb: '000000' }, // Black text color
            };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2); // Second column cell (column B)
            secondCell.font = {
                color: { argb: '33bbff' }, // Blue text color (hex: #0000FF)
            };
        });
        // Set column width
        // Adjust column width dynamically based on content length
        worksheet.columns.forEach((column, index) => {
            let maxLength = 0;

            // Iterate over all rows in the column and find the maximum length
            worksheet.getColumn(index + 1).eachCell((cell) => {
                const cellLength = (cell.value || '').toString().length; // Get length of the cell content
                maxLength = Math.max(maxLength, cellLength); // Update max length
            });

            // Set the column width based on the maximum length
            worksheet.getColumn(index + 1).width = maxLength + 2; // Adding some padding for better readability
        });


        // Save the Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${fpsId}.xlsx`;
        link.click();
    };





    // Effect to perform actions when report becomes visible
    useEffect(() => {
        if (showDownloadPdf) {
            // This will run when the report is visible (i.e., after the button is clicked)

            // Scroll the page to the table (if you want to scroll to the table)
            if (reportRef.current) {
                reportRef.current.scrollIntoView({ behavior: 'smooth' });
            }
            //  console.log("Report is now visible");
            //  console.log(tableData);  // You can also log or manipulate tableData here
        }
    }, [showDownloadPdf]); // Trigger effect when showDownloadPdf state changes
    // Token you provided (for testing purposes)

    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;  // Define the base URL
    useEffect(() => {
        // console.log('Token:', token);  // Check if token is set
        if (token) {
            axios.get(`${baseUrl}/districts`, {
                headers: { Authorization: `Bearer ${token}` },
            })
                .then((response) => {
                    //  console.log("API Response:", response.data);  // Log entire response
                    if (response.data && response.data.data && Array.isArray(response.data.data)) {
                        setDistricts(response.data.data);  // Set the state
                        //    console.log("Districts State:", response.data); // Log districts state after setting it
                    } else {
                        setError("Invalid response format");
                    }
                })
                .catch((error) => {
                    setError("Error fetching districts");
                    console.error("Error fetching districts:", error);
                });
        } else {
            setError("No token found. Please log in.");
        }
    }, [token]);










    const getLocalImagePath = (imageUrl) => {
        const externalBaseUrl = "https://parakhfiles.s3.ap-south-1.amazonaws.com"; // Your external base URL
        const localBasePath = "https://d2qyrr1tl2df8g.cloudfront.net"; // Your local folder base path

        // Log the original image URL
        // console.log('Original Image URL:', imageUrl);

        // Check if the image URL starts with the external base URL
        if (imageUrl.startsWith(externalBaseUrl)) {
            // Get the relative part of the URL (remove external base URL part)
            const relativePath = imageUrl.substring(externalBaseUrl.length);

            // Create the local path by appending the relative path to the local base folder
            const localPath = localBasePath + relativePath;

            // Log the final local path
            // console.log('Converted to Local Path:', localPath);

            // Return the local path for the image
            return localPath;
        }

        // If the URL doesn't match the external base URL, return it as is
        // console.log('Returning original URL as local path:', imageUrl);
        return imageUrl;
    };


    const fpsId = localStorage.getItem('fpsId');
    const dateOfInspection = localStorage.getItem('startTime');
    const username = localStorage.getItem('username');

    // console.log("username", username); // Log to verify values
    // console.log("dateofisnpec", dateOfInspection);
    //console.log("fpsid", fpsId);
    useEffect(() => {
        if (!fpsId || !dateOfInspection || !username) {
            setError('Missing FPS ID or Date of Inspection');
            // setLoading(false);
            return; // Exit early if missing fpsId or dateOfInspection
        }

        const fetchData = async () => {
            try {
                // setLoading(true); // Set loading to true when starting the request

                // Retrieve the token from localStorage (or any other secure storage)
                //const token = '7afc6a17404f3b863333e277746c2f1764efa956bbcd6cb2480e276dc7d7e7a3cae7882f9f4414164e9e3b054b14272522b665c7ab8d84c1a41545acdb551446e16d2e19a8d266d032601d2b4a922ed1c0f928bc72967f21f73236fea64230a8bf3832a7765f817231f96721a400a57fd765a4a1d286c6b979183ba68e2a5fa5';
                const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
                // Ensure that the token is available before making the request
                if (!token) {
                    throw new Error('No authentication token available');
                }

                // Make the API request using axios
                const url = `${process.env.REACT_APP_AUDIT_API_URL}/api/survey/reports/user/${username}/fps/${fpsId}/date/${dateOfInspection}`;


                const response = await axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                // Check if the response contains data
                if (response.data && response.data.data) {
                    // console.log('Response:', response.data.data);
                    setTableData(response.data.data);  // Update tableData with the array from the response
                    setShowDownloadPdf(true);          // Toggle visibility of download button
                    setDataMessage('');
                } else {
                    console.error('No data found');
                    //  setShowDownloadPdf(false);  // Hide download PDF option if no data
                    setDataMessage('Data is not available');
                }
            } catch (error) {
                console.error('Error fetching report:', error);
                setError('Error fetching report data');
            } finally {
                //  setLoading(false); // Set loading to false after the request is finished
            }
        };

        // Fetch the data
        fetchData();
    }, [fpsId, dateOfInspection]); // This effect runs when fpsId or dateOfInspection changes




    // Controlled dropdown open/close
    const toggleDropdown = () => {
        setIsOpen((prevState) => !prevState);
    };
    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };



    const getFirstDataByQuestionUid = (uid) => {
        // Ensure that tableData is an array
        if (tableData) {
            // Filter the data based on the questionUid within the questionSurveys
            const filteredData =
                // tableData.filter(item => {
                // Check if item.questionSurveys is an array and has the required structure
                tableData.questionSurveys && tableData.questionSurveys.some(survey =>
                    survey?.question?.questionUid === uid
                );
            // });

            // Return the first matching data, or null if no match found
            return filteredData;
        } else {
            console.error("tableData is not an array or is undefined:", tableData);
            return null;
        }
    };


    const questionSurveys = tableData ? tableData.questionSurveys : [];
    const geoTaggedPhotos = tableData ? tableData.geoTaggedPhotos : [];
    const benQuestionSurveys = tableData ? tableData.benQuestionSurveys : [];
    const fpsid = tableData ? tableData.fpsId : [];
    const district = tableData ? tableData.district : [];
    const subDivision = tableData ? tableData.subDivision : [];
    const block = tableData ? tableData.block : [];
    const panchayat = tableData ? tableData.panchayat : [];
    const formatNumber = (value) => {
        const parsedValue = parseFloat(value);

        // Check if it's a number and not NaN
        if (!isNaN(parsedValue)) {
            // If the value is very small or zero, ensure it's displayed with two decimal places
            return parsedValue.toFixed(2);
        }
        // Otherwise, return the original value (in case it's text)
        return value;
    };
    const formatNumberComa = (value) => {


        // Check if it's a number and not NaN
        if (!isNaN(value)) {
            // If the value is very small or zero, ensure it's displayed with two decimal places
            return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        // Otherwise, return the original value (in case it's text)
        return value;
    };
    return (
        <div className="fpshopinsepectionreport-view" ref={reportRef}>
            {/* const fpsId = localStorage.getItem('fpsId');
    const fpsId = localStorage.getItem('fpsId'); */}
            {dataMessage && <p style={{ textAlign: "center", color: "red" }} >No Survey Found for FPS {fpsId} for user with username {username} time {dateOfInspection}</p>}

            {showDownloadPdf && (
                <div className="fps-Report-table-container">

                    <div className="FPSReport-header-15">
                        <button onClick={generatePDF} className="insepectioncreateUser-btn">
                            DOWNLOAD PDF
                        </button>
                        <button onClick={generateExcel} className="insepectioncreateUser-btn">
                            DOWNLOAD XLSX
                        </button>
                    </div>
                    <table className="fps-Report-shop-table">
                        <thead>
                            <tr className="FPSReport-table-header">
                                <th colSpan="2" className="fpsheading-user">{questionSurveys?.find(survey => survey.question?.questionUid === '55')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{formatFullName(questionSurveys?.find(survey => survey.question?.questionUid === '55')?.response || 'No Response')}</strong></th>
                            </tr>

                        </thead>
                        <thead>
                            <tr className="FPSReport-table-header">
                                <th colSpan="2" className="fpsheading">User Information</th>
                            </tr>
                        </thead>
                        <tbody >
                            <tr>
                                <td>
                                    FPS ID: <strong className="red-text-3">
                                        {fpsid || 'No FPS ID'}
                                    </strong>
                                </td>
                                <td>
                                    District Name: <strong className="red-text-3">
                                        {capitalizeFirstLetter(district) || 'No District'}
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Sub-Division Name: <strong className="red-text-3">
                                        {capitalizeFirstLetter(subDivision) || 'No SubDivision'}
                                    </strong>
                                </td>
                                <td>
                                    Block Name: <strong className="red-text-3">
                                        {capitalizeFirstLetter(block) || 'No Block'}
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Panchayat Name : <strong className="red-text-3">
                                        {capitalizeFirstLetter(panchayat) || 'No Panchayat'}
                                    </strong>
                                </td>

                            </tr>
                        </tbody>
                        <thead>
                            <tr className="FPSReport-table-header">
                                <th colSpan="2" className="fpsheading">General Information</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '1')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '1')?.response || 'No Response'}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '2')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '2')?.response || 'No Response'}</strong></td>
                            </tr>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '3')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '3')?.response || 'No Response'}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '4')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '4')?.response || 'No Response'}</strong></td>
                            </tr>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '5')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '5')?.response || 'No Response'}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '6')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '6')?.response || 'No Response'}</strong></td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr className="FPSReport-table-header">
                                <th colSpan="2" className="fpsheading">Shop Operations</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '7')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '7')?.response || 'No Response')}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '8')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '8')?.response || 'No Response')}</strong></td>
                            </tr>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '9')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '9')?.response || 'No Response')}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '10')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '10')?.response || 'No Response')}</strong></td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr className="FPSReport-table-header">
                                <th colSpan="2" className="fpsheading"> Record Maintenance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '11')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '11')?.response || 'No Response')}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '12')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '12')?.response || 'No Response')}</strong></td>
                            </tr>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '13')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '13')?.response || 'No Response')}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '14')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '14')?.response || 'No Response')}</strong></td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr className="FPSReport-table-header">
                                <th colSpan="2" className="fpsheading"> Display of Information</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '15')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '15')?.response || 'No Response')}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '16')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '16')?.response || 'No Response')}</strong></td>
                            </tr>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '17')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '17')?.response || 'No Response')}</strong></td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr className="FPSReport-table-header">
                                <th colSpan="2" className="fpsheading"> Infrastructure</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{geoTaggedPhotos?.find(survey => survey.question?.questionUid === '20')?.question?.questionText || 'No Data'}:
                                    <strong className="red-text-3">
                                        {geoTaggedPhotos?.find(survey => survey.question?.questionUid === '20')?.url ?
                                            <>
                                                {/* {console.log('Image URL:', geoTaggedPhotos.find(survey => survey.question?.questionUid === '20')?.url)} */}
                                                <img
                                                    src={getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '20')?.url)}
                                                    alt="Geo-tagged 20"
                                                    style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                    onClick={() => openModal(getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '20')?.url, 'Geo-tagged 20'))} />
                                            </>
                                            : '#'}
                                    </strong>
                                </td>
                                <td>{geoTaggedPhotos?.find(survey => survey.question?.questionUid === '21')?.question?.questionText || 'No Data'}:
                                    <strong className="red-text-3">
                                        {geoTaggedPhotos?.find(survey => survey.question?.questionUid === '21')?.url ?
                                            <>
                                                {/* {console.log('Image URL:', geoTaggedPhotos.find(survey => survey.question?.questionUid === '21')?.url)} */}
                                                <img
                                                    src={getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '21')?.url)}
                                                    alt="Geo-tagged 20"
                                                    style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                    onClick={() => openModal(getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '21')?.url, 'Geo-tagged 20'))} />
                                            </>
                                            : '#'}
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td>{geoTaggedPhotos?.find(survey => survey.question?.questionUid === '22')?.question?.questionText || 'No Data'}:
                                    <strong className="red-text-3">
                                        {geoTaggedPhotos?.find(survey => survey.question?.questionUid === '22')?.url ?
                                            <>
                                                {/* {console.log('Image URL:', geoTaggedPhotos.find(survey => survey.question?.questionUid === '22')?.url)} */}
                                                <img
                                                    src={getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '22')?.url)}
                                                    alt="Geo-tagged 20"
                                                    style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                    onClick={() => openModal(getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '22')?.url, 'Geo-tagged 20'))} />
                                            </>
                                            : '#'}
                                    </strong>
                                </td>
                                <td>{geoTaggedPhotos?.find(survey => survey.question?.questionUid === '23')?.question?.questionText || 'No Data'}:
                                    <strong className="red-text-3">
                                        {geoTaggedPhotos?.find(survey => survey.question?.questionUid === '23')?.url ?
                                            <>
                                                {/* {console.log('Image URL:', geoTaggedPhotos.find(survey => survey.question?.questionUid === '23')?.url)} */}
                                                <img
                                                    src={getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '23')?.url)}
                                                    alt="Geo-tagged 20"
                                                    style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                    onClick={() => openModal(getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '23')?.url, 'Geo-tagged 20'))} />
                                            </>
                                            : '#'}
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td>{geoTaggedPhotos?.find(survey => survey.question?.questionUid === '24')?.question?.questionText || 'No Data'}:
                                    <strong className="red-text-3">
                                        {geoTaggedPhotos?.find(survey => survey.question?.questionUid === '24')?.url ?
                                            <>
                                                {/* {console.log('Image URL:', geoTaggedPhotos.find(survey => survey.question?.questionUid === '24')?.url)} */}
                                                <img
                                                    src={getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '24')?.url)}
                                                    alt="Geo-tagged 20"
                                                    style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                    onClick={() => openModal(getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '24')?.url, 'Geo-tagged 20'))} />
                                            </>
                                            : '#'}
                                    </strong>
                                </td>


                                <td>{geoTaggedPhotos?.find(survey => survey.question?.questionUid === '25')?.question?.questionText || 'No Data'}:
                                    <strong className="red-text-3">
                                        {geoTaggedPhotos?.find(survey => survey.question?.questionUid === '25')?.url ?
                                            <>
                                                {/* {console.log('Image URL:', geoTaggedPhotos.find(survey => survey.question?.questionUid === '25')?.url)} */}
                                                <img
                                                    src={getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '25')?.url)}
                                                    alt="Geo-tagged 20"
                                                    style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                    onClick={() => openModal(getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '25')?.url, 'Geo-tagged 20'))} />
                                            </>
                                            : '#'}
                                    </strong>
                                </td>

                            </tr>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '18')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '18')?.response || 'No Response')}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '19')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '19')?.response || 'No Response')}</strong></td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr className="FPSReport-table-header">
                                <th colSpan="2" className="fpsheading"> Technology Integration</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '26')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '26')?.response || 'No Response')}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '27')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '27')?.response || 'No Response')}</strong></td>
                            </tr>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '28')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '28')?.response || 'No Response')}</strong></td>

                            </tr>


                        </tbody>

                        <thead>
                            <tr className="FPSReport-table-header">
                                <th colSpan="2" className="fpsheading">Beneficiary Targeting & Coverage</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '29')?.question?.questionText || 'No Data'}:<strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '29')?.response ? formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '29')?.response) : 'No Response'}</strong></td>


                                <td></td>
                            </tr>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '30')?.question?.questionText || 'No Data'}:<strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '30')?.response ? formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '30')?.response) : 'No Response'}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '32')?.question?.questionText || 'No Data'}:<strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '32')?.response ? formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '32')?.response) : 'No Response'}</strong></td>


                            </tr>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '31')?.question?.questionText || 'No Data'}:<strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '31')?.response ? formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '31')?.response) : 'No Response'}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '33')?.question?.questionText || 'No Data'}:<strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '33')?.response ? formatNumberComa(questionSurveys?.find(survey => survey.question?.questionUid === '33')?.response) : 'No Response'}</strong></td>


                            </tr>

                        </tbody>

                        <thead>
                            <tr className="FPSReport-table-header">
                                <th colSpan="2" className="fpsheading">Inventory Verification</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>

                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '34')?.question?.questionText || 'No Data'}:<strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '34')?.response ? formatNumber(parseFloat(questionSurveys.find(survey => survey.question?.questionUid === '34')?.response).toFixed(2)) : 'No Response'}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '36')?.question?.questionText || 'No Data'}:<strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '36')?.response ? formatNumber(parseFloat(questionSurveys.find(survey => survey.question?.questionUid === '36')?.response).toFixed(2)) : 'No Response'}</strong></td>


                            </tr>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '35')?.question?.questionText || 'No Data'}:<strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '35')?.response ? formatNumber(parseFloat(questionSurveys.find(survey => survey.question?.questionUid === '35')?.response).toFixed(2)) : 'No Response'}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '37')?.question?.questionText || 'No Data'}:<strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '37')?.response ? formatNumber(parseFloat(questionSurveys.find(survey => survey.question?.questionUid === '37')?.response).toFixed(2)) : 'No Response'}</strong></td>

                            </tr>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '38')?.question?.questionText || 'No Data'}:<strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '38')?.response ? formatNumber(parseFloat(questionSurveys.find(survey => survey.question?.questionUid === '38')?.response).toFixed(2)) : 'No Response'}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '39')?.question?.questionText || 'No Data'}:<strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '39')?.response ? formatNumber(parseFloat(questionSurveys.find(survey => survey.question?.questionUid === '39')?.response).toFixed(2)) : 'No Response'}</strong></td>

                            </tr>
                            <tr>
                                <td>
                                    {questionSurveys?.find(survey => survey.question?.questionUid === '40')?.question?.questionText || 'No Data'}(Qtl): <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '40')?.response ? formatNumber(parseFloat(questionSurveys.find(survey => survey.question?.questionUid === '40')?.response).toFixed(2)) : 'No Response'}</strong></td>
                                <td>
                                    {questionSurveys?.find(survey => survey.question?.questionUid === '41')?.question?.questionText || 'No Data'}(Qtl): <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '41')?.response ? formatNumber(parseFloat(questionSurveys.find(survey => survey.question?.questionUid === '41')?.response).toFixed(2)) : 'No Response'}</strong></td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr className="FPSReport-table-header">
                                <th colSpan="2" className="fpsheading">Beneficiary Feedback</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Iterate through each survey */}
                            {benQuestionSurveys?.map((survey, index) => {
                                return (
                                    <React.Fragment key={index}>
                                        {/* Render the Ration Number and Card Holder Name */}
                                        <tr>
                                            <td>
                                                Ration Card Number: <strong className="red-text-4">
                                                    {survey?.rationNumber || 'No Data'}
                                                </strong>
                                            </td>
                                            <td>
                                                Card Holder Name: <strong className="red-text-3">
                                                    {capitalizeFirstTwoWords(survey?.cardHolderName) || 'No Data'}
                                                </strong>
                                            </td>
                                        </tr>
                                        {/* Render all questions and responses side by side */}
                                        {survey?.benQuestionResponseArray
                                            ?.filter(question => question?.questionText !== "Ration/Aadhar Card No" && question?.questionText !== "Card Holder Name")  // Filter out unwanted questions
                                            .reduce((acc, question, index) => {
                                                // Group questions based on index (two questions per rationNumber)
                                                if (index % 2 === 0) {
                                                    acc.push([question]);  // Start a new group for every two questions
                                                } else {
                                                    acc[acc.length - 1].push(question);  // Add to the last group
                                                }
                                                return acc;
                                            }, [])
                                            .map((questionPair, pairIndex) => {
                                                return (
                                                    <tr key={pairIndex}>
                                                        {/* First <td>: Render Question and Response for the second question on the left side */}
                                                        <td>
                                                            {questionPair[1]?.questionText}
                                                            <strong className="red-text-3">
                                                                {questionPair[1]?.response}
                                                            </strong>
                                                        </td>
                                                        {/* Second <td>: Render Question and Response for the first question on the right side */}
                                                        <td>
                                                            {questionPair[0]?.questionText}
                                                            <strong className="red-text-3">
                                                                {questionPair[0]?.response}
                                                            </strong>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                        <thead>
                            <tr className="FPSReport-table-header">
                                <th colSpan="2" className="fpsheading">Inspecting Officer Feedback</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {/* Check if the data exists for the first question */}
                                {questionSurveys?.find(survey => survey.question?.questionUid === '53')?.response && (
                                    <td>
                                        {questionSurveys.find(survey => survey.question?.questionUid === '53')?.question?.questionText || 'No Data'}:
                                        <strong className="red-text-3">
                                            {questionSurveys.find(survey => survey.question?.questionUid === '53')?.response || 'No Response'}
                                        </strong>
                                    </td>
                                )}
                                {/* Check if the data exists for the second question (Geo-tagged photo) */}
                                {geoTaggedPhotos?.find(survey => survey.question?.questionUid === '54')?.url && (
                                    <td>
                                        {geoTaggedPhotos.find(survey => survey.question?.questionUid === '54')?.question?.questionText || '#'}:
                                        <strong className="red-text-3">
                                            <img
                                                src={getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '54')?.url)}
                                                alt="Geo-tagged 20"
                                                style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                onClick={() => openModal(getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '54')?.url, 'Geo-tagged photo 20'))}
                                            />
                                        </strong>
                                    </td>
                                )}
                            </tr>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '55')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{formatFullName(questionSurveys?.find(survey => survey.question?.questionUid === '55')?.response || 'No Response')}</strong></td>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '56')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '56')?.response || 'No Response'}</strong></td>
                            </tr>
                            <tr>
                                <td>{questionSurveys?.find(survey => survey.question?.questionUid === '57')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '57')?.response || 'No Response'}</strong></td>
                                <td>{geoTaggedPhotos?.find(survey => survey.question?.questionUid === '58')?.question?.questionText || 'No Data'}:
                                    <strong className="red-text-3">
                                        {geoTaggedPhotos?.find(survey => survey.question?.questionUid === '58')?.url ?
                                            <>
                                                {/* {console.log('Image URL:', geoTaggedPhotos.find(survey => survey.question?.questionUid === '58')?.url)} */}
                                                <img
                                                    src={getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '58')?.url)}
                                                    alt="Geo-tagged 20"
                                                    style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                    onClick={() => openModal(getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '58')?.url, 'Geo-tagged 20'))} />
                                            </>
                                            : '#'}
                                    </strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>


                    <div id="imageModal" className="modal" ref={modalRef}>
                        <span className="close" onClick={closeModal}>&times;</span>
                        <img className="modal-content" ref={modalImageRef} />
                        {/* <div id="caption" ref={captionRef}></div> */}
                    </div>
                </div>
            )}

        </div>
    );
}
export default FPSShopInspectionTwo;